import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalDiagramRename, diagramRename } from '../../../redux/main/main.actions';
import { selectIsModalDiagramRenameEnabled, selectModalDiagramRenameData } from '../../../redux/main/main.selectors';

import Modal from '../Modal/Modal';
import './ModalDiagramRename.scss';

export const ModalDiagramRename = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramRenameEnabled);
    const modalData = useSelector(selectModalDiagramRenameData);

    const inputRef = useRef(null);
    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        const updatedValue = value || 'Untitled';
        // setValue(updatedValue);
        dispatch(diagramRename(modalData?.diagram?.id, { title: updatedValue }));
        dispatch(toggleModalDiagramRename(null));

        setTimeout(() => {
            setValue(modalData?.diagram?.title || '');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramRename(null));
        setTimeout(() => {
            setValue(modalData?.diagram?.title);
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-rename`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`Rename diagram`}</div>
            <div className="modal-content-body">

                <div className="description-text">Enter a new diagram name</div>

                <input
                    maxLength="1000"
                    ref={inputRef}
                    autoComplete="off"
                    spellCheck="false"
                    type="text"
                    id="diagram-name"
                    placeholder="Enter a new diagram name"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>Cancel</button>
                    <button onClick={() => handleSave()}>Rename</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramRename;
